import { render, staticRenderFns } from "./PartnersCn.vue?vue&type=template&id=33f546bf&scoped=true&"
import script from "./PartnersCn.vue?vue&type=script&lang=js&"
export * from "./PartnersCn.vue?vue&type=script&lang=js&"
import style0 from "./PartnersCn.vue?vue&type=style&index=0&id=33f546bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f546bf",
  null
  
)

export default component.exports